import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public list_user: any = [];
  public loading: boolean = false;
  public subscription: Subscription | any;
  public server!: string;
  public site!: string;
  public no_record!: string;
  public title_search: string;
  public creator!: number;
  public code!: any;
  public user_id!: number;
  public user!: number;
  public show_cellphone: boolean = true;
  public dataSource: any;
  public displayedColumns: any = ['row', 'user', 'cellphone', 'phone', 'balance'];

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public messageService: MessageService,
    public matDialogRef: MatDialogRef<UserSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    this.server = this.serverService.get_server();
    this.site = this.serverService.get_site();
    this.no_record = this.serverService.no_record();

    if (dialog_data) {
      this.code = dialog_data.code;
      this.user = dialog_data.user;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.check_access();
  }
  check_access(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
          }
          else {
            this.creator = res['creator'];
            this.show_cellphone = res['show_cellphone'];
            this.get_user(1);
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  get_user(type: number) {
    if (!this.creator) {
      return false;
    }
    if (type == 1) this.loading = true;
    //1731
    var obj = {
      'address': 6799,
      'title': this.title_search,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_user = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_user.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_user);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  select(id: number, title: string) {
    this.matDialogRef.close({ id: id, title: title })
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

